import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './modules/auth/login/login.component';
import { PagesComponent } from './modules/pages/pages.component';

const routes: Routes = [
  {
    path: '', component: PagesComponent, children: [
      { path: '', redirectTo: '/Invoice', pathMatch: 'full' }
    ]
  },
  { path: 'Login', component: LoginComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule
  ],
  declarations: []
})
export class AppRoutingModule { }
